var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Rd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1956_8936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90225 4.648C5.86492 3.88 8.05158 3.496 10.4622 3.496C12.8942 3.496 14.6649 3.96533 15.7743 4.904C16.8836 5.82133 17.4382 7.304 17.4382 9.352C17.4382 11.4 16.6169 12.968 14.9742 14.056C15.9983 14.6107 16.7236 15.1867 17.1502 15.784C17.5982 16.3813 17.8222 17.3307 17.8222 18.632C17.8222 20.9147 17.2462 22.6107 16.0942 23.72C14.9636 24.8293 13.1396 25.384 10.6222 25.384C8.76625 25.384 6.81425 25.1067 4.76625 24.552L3.74225 24.296L3.96625 20.936C6.35558 21.3413 8.36092 21.544 9.98225 21.544C12.1796 21.544 13.2782 20.6053 13.2782 18.728C13.2782 17.9387 12.9902 17.3093 12.4142 16.84C11.8596 16.3707 11.1236 16.136 10.2062 16.136H5.95025V12.488H10.2062C10.9102 12.488 11.5289 12.1893 12.0622 11.592C12.6169 10.9947 12.8942 10.3333 12.8942 9.608C12.8942 8.09333 11.8382 7.336 9.72625 7.336C8.25425 7.336 6.68625 7.48533 5.02225 7.784L4.19025 7.912L3.90225 4.648ZM21.0149 14V4.4H23.5685V5.4176C24.6437 4.7776 25.6677 4.3616 26.6405 4.1696V6.7616C25.6037 6.9792 24.7141 7.2032 23.9717 7.4336L23.5877 7.568V14H21.0149ZM36.8946 0.559999V14H34.341V13.5968C33.445 14.0192 32.6706 14.2304 32.0178 14.2304C30.6226 14.2304 29.6498 13.8272 29.0994 13.0208C28.549 12.2144 28.2738 10.9408 28.2738 9.2C28.2738 7.4464 28.6002 6.1728 29.253 5.3792C29.9186 4.5728 30.917 4.1696 32.2482 4.1696C32.6578 4.1696 33.2274 4.2336 33.957 4.3616L34.3218 4.4384V0.559999H36.8946ZM34.053 11.696L34.3218 11.6384V6.5888C33.6178 6.4608 32.9906 6.3968 32.4402 6.3968C31.4034 6.3968 30.885 7.3184 30.885 9.1616C30.885 10.16 31.0002 10.8704 31.2306 11.2928C31.461 11.7152 31.8386 11.9264 32.3634 11.9264C32.901 11.9264 33.4642 11.8496 34.053 11.696Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1956_8936",
    x: 0.74231,
    y: 0.55957,
    width: 39.1523,
    height: 30.8242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1956_8936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1956_8936",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Rd);
export default __webpack_public_path__ + "static/media/3rd.64915160f97f3b182646ca87642c49cf.svg";
export { ForwardRef as ReactComponent };